import { TableSortLabel, TableCell, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { getDescendantProp } from './CommonFunctions';


export interface ISortableComponent { sortField: string | null, sortAscending: boolean }

const stickyStyle = {position: "sticky",top: 0, backgroundColor: 'white'}

interface IColHeaderProps { context: Component<any,ISortableComponent>, fieldName: string, title: string, onSort(sortField: string | null, sortAscending: boolean): void}
const ColHeader: React.FC<IColHeaderProps> = (props) => {
    return (
        <TableCell>
            <TableSortLabel
                active={props.context.state.sortField === props.fieldName}
                direction={props.context.state.sortAscending ? 'asc' : 'desc'}
                onClick={() => props.context.setState({ sortAscending: !props.context.state.sortAscending, sortField: props.fieldName }, 
                    () => props.onSort(props.context.state.sortField, props.context.state.sortAscending))}
            >
                <Typography variant="button">{props.title}</Typography>
            </TableSortLabel>
        </TableCell>
    )
}

export function sort<T>(sortField: string | null, sortAscending: boolean, products?: T[] | null): T[] | null{
    if (sortField === null)
           if (products != undefined)
                return products

    if (products != null){
        let sorted: T[] = products.slice()
        const field: string = sortField!

        let orderModifier = sortAscending ? 1 : -1
        sorted.sort((a, b) => (getDescendantProp((a), field) > getDescendantProp((b), field) ? orderModifier * 1 : orderModifier * -1))

        return sorted
    }
    else
        return null
}

export default ColHeader;